module.exports = __webpack_public_path__ + "media/images/bg/hex-slices-seledyn-f8e53d8b5895f6b84a64e166a2facfa0.svg";